import { z } from "zod";

const showStatuses = ["all", "airing", "upcoming", "returning", "ended", "cancelled"] as const;

export const discoverySearchSchema = z.object({
  q: z.string().trim().max(120).optional().catch(undefined),
  genre: z.string().trim().max(60).optional().catch(undefined),
  status: z.enum(showStatuses).optional().catch(undefined),
  year: z.coerce.number().int().min(1900).max(2100).optional().catch(undefined),
  region: z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{2}$/u)
    .optional()
    .catch(undefined),
});
